import { environment } from './../../../../environments/environment';
import { timer as observableTimer, Observable } from 'rxjs';
import { takeWhile, take } from 'rxjs/operators';
import { ModalComponent } from './../../../shared/modais/modal/modal.component';
import { Component, OnInit, Input, OnDestroy, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { FichaCadastroSharedService } from './../shared/ficha-cadastro-shared.service';
import { FichaService } from '../../ficha-veiculo.service';
import { FichaCadastro } from './../ficha-cadastro';

import { DadoSimulacao } from './../ficha-cadastro-resultado-parcial/model/dado-simulacao';
import { PropostaSimulacao } from './../ficha-cadastro-resultado-parcial/model/proposta/proposta-simulacao';
import { ModalMessageComponent } from './../../../shared/modais/modal-message/modal-message.component';
import { StorageService } from '../../../services/storage/storage.service';
import { differenceInMilliseconds } from 'date-fns';
import { VeiculoPendencia } from '../model/veiculo';
import { VeiculoSimulacao } from '../ficha-cadastro-resultado-parcial/model/proposta/veiculo-simulacao';
import { LoginStorage } from './../../../login/login.storage';
import { Originador } from './../../../services/pesados-brasil/originador.interface';

@Component({
  selector: 'app-ficha-cadastro-consultando-dados',
  templateUrl: './ficha-cadastro-consultando-dados.component.html',
  styleUrls: ['./ficha-cadastro-consultando-dados.component.css'],
})
export class FichaCadastroConsultandoDadosComponent
  implements OnInit, OnDestroy
{
  @Input() fichaCadastro: FichaCadastro;

  @ViewChild('modalMessage', { static: true })
  modalMessage: ModalMessageComponent;
  @ViewChild('messageReturnHome', { static: true })
  messageReturnHome: ModalComponent;

  hideClose: boolean = true;

  private isAlive = true;
  private isConsultarAnaliseProposta = false;
  private isExecutandoSimulacao = false;
  private numero = 0;
  private tentativaDados = 0;
  private isTelaSimulacao = true;

  private readonly SUCCESS: string = 'SUCCESS';
  private readonly ANALISE_PENDENTE: string = 'ANALISE_PENDENTE';
  private readonly REFUSED: string = 'REFUSED';
  private readonly FIPE_NOT_FOUND: string = 'FIPE_NOT_FOUND';
  private readonly PLACA_INVALIDA: string = 'PLACA_INVALIDA';
  private readonly TAXA_CLIENTE_NOT_FOUND: string = 'TAXA_CLIENTE_NOT_FOUND';
  private readonly ERRO_CRIVO: string = 'CRIVO_ERRO';
  private readonly AGUARDANDO_CARREGAMENTO: string = 'AGUARDANDO_CARREGAMENTO';
  private readonly GARANTIA_RECUSADA: string = 'GARANTIA_RECUSADA';
  private readonly VEICULOS_PENDENTE: string = 'VEICULOS_PENDENTE';

  private originador: Originador;

  constructor(
    private sharedService: FichaCadastroSharedService,
    private fichaService: FichaService,
    private router: Router,
    private storageService: StorageService,
    private loginStorage: LoginStorage
  ) {}

  ngOnInit() {
    this.initObservableSimular();
    this.originador = this.loginStorage.originator;
  }

  ngOnDestroy() {
    this.isTelaSimulacao = false;
    this.isAlive = false;
    this.endControlesObservables();
  }

  private endControlesObservables() {
    this.isConsultarAnaliseProposta = false;
    this.isExecutandoSimulacao = false;
  }

  private initObservableSimular() {
    this.sharedService.simularPropostaObservable
      .pipe(takeWhile(() => this.isAlive))
      .subscribe((simular: boolean) => {
        if (simular) {
          this.simularProposta();
        }
      });
  }

  private simularProposta() {
    const { lastTimeAProposalStarted } = this.storageService.getLocal();

    if (lastTimeAProposalStarted) {
      this.fichaCadastro.setPayload(
        'tempoGastoFicha',
        differenceInMilliseconds(new Date(), lastTimeAProposalStarted)
      );
    } else {
      this.fichaCadastro.setPayload('tempoGastoFicha', 0);
    }

    if (this.originador && this.originador.originador) {
      this.fichaCadastro.setPayload(
        'tipoOriginador',
        this.originador.typesOrigination[0].code
      );
    }

    const payload = this.fichaCadastro.getPayload();
    if (payload && payload.veiculoProprioTemp) {
      delete payload.veiculoProprioTemp;
    }

    this.fichaService
      .simular(payload)
      .pipe(takeWhile(() => this.isAlive))
      .subscribe(
        (result) => {
          if (this.verificarPropostaDuplicada(result)) {
            return;
          }

          this.iniciarVariaveis(result);
          this.iniciarConsultaAnaliseProposta(result);
          this.storageService.removeLocalItem('lastTimeAProposalStarted');
        },
        (error) => this.handleErrorSimulacao(error.error, null)
      );
  }

  private verificarPropostaDuplicada(result: any): boolean {
    const status = result.status;
    const messages = result.messages;
    const isErro =
      status === 'PROPOSTA_DUPLICADA' || (messages && messages.length > 0);

    if (isErro) {
      this.isConsultarAnaliseProposta = false;
      this.isExecutandoSimulacao = false;
      this.tentativaDados = 0;

      const mensagemErro =
        messages.join('\n') || 'Ocorreu um erro na simulação';
      this.showErrorMessage(mensagemErro, () => this.home());
      return true;
    }
    return false;
  }

  private iniciarVariaveis(result) {
    if (result.timeout) {
      this.isConsultarAnaliseProposta = true;
    }
  }

  private returnHomeWithMessage(): void {
    this.messageReturnHome
      .show()
      .modalClose.pipe(take(1))
      .subscribe(() => this.home());
  }

  private iniciarConsultaAnaliseProposta(result) {
    if ((result.proposta || {}).id) {
      this.isExecutandoSimulacao = false;
      const dadoSimulacao: DadoSimulacao = new DadoSimulacao();
      dadoSimulacao.setNumeroProposta(result.proposta.id);
      const timerConsulta = observableTimer(1000, 5000);
      timerConsulta
        .pipe(takeWhile(() => this.isConsultarAnaliseProposta))
        .subscribe(() => {
          this.consultarAnaliseProposta(dadoSimulacao);
        });
    }
  }

  private consultarAnaliseProposta(dadoSimulacao: DadoSimulacao) {
    if (!this.isExecutandoSimulacao && this.isTelaSimulacao) {
      this.isExecutandoSimulacao = true;
      this.fichaService
        .getDadosProposta(dadoSimulacao.getNumeroProposta())
        .pipe(takeWhile(() => this.isExecutandoSimulacao))
        .subscribe(
          (result) => this.handleResultDadoSimulacao(result, dadoSimulacao),
          (error) => this.handleErrorSimulacao(error.error, dadoSimulacao)
        );
    }
  }

  private handleResultDadoSimulacao(result, dadoSimulacao: DadoSimulacao) {
    if (result.status === this.AGUARDANDO_CARREGAMENTO) {
      this.isConsultarAnaliseProposta = false;
      this.isExecutandoSimulacao = false;
      if (
        this.tentativaDados <= this.loginStorage.simulacaoTentativas &&
        this.isTelaSimulacao
      ) {
        setTimeout(
          () => this.consultarAnaliseProposta(dadoSimulacao),
          this.loginStorage.simulacaoTempo
        );
      } else {
        this.returnHomeWithMessage();
      }
      this.tentativaDados++;
    } else {
      this.fichaCadastro.setErrorStatus(result.status);

      if (result.status === this.REFUSED) {
        this.handleErrorRefused(result.message);
      }

      if (result.status === this.VEICULOS_PENDENTE) {
        this.tentativaDados = 0;
        const proposta = new PropostaSimulacao(result);
        this.fichaCadastro.veiculosGetDados = proposta.veiculos;
        this.fichaCadastro.veiculosPendencia = proposta.veiculosPendencia;
        this.mergeVeiculoPendenciaGetDados();
        this.fichaCadastro.setIdSimulacao(proposta.getIdSimulacao());
        this.sharedService.verificaPendenciaVeiculo();
        this.fichaCadastro.setPasso(this.fichaCadastro.PASSO_VEICULO);
        return;
      }

      if (
        result.status !== this.ANALISE_PENDENTE &&
        result.status !== this.REFUSED
      ) {
        const proposta = new PropostaSimulacao(result);
        this.isExecutandoSimulacao = false;
        this.endControlesObservables();
        if (this.router.url.includes('resultadoparcial')) {
          this.fichaCadastro.setPasso(
            this.fichaCadastro.PASSO_RESULTADO_PARCIAL
          );
          this.sharedService.simulacaoResultadoParcial(result);
        } else {
          this.router.navigate(['resultadoparcial', proposta.id]);
        }
      }
    }
  }

  private mergeVeiculoPendenciaGetDados(): void {
    const placasVeiculos = this.fichaCadastro.veiculosGetDados
      .map((m) => m.placa)
      .filter((f) => f);
    this.fichaCadastro.veiculosPendencia.forEach((veiculoPendencia) => {
      if (
        veiculoPendencia.placa &&
        !placasVeiculos.includes(veiculoPendencia.placa)
      ) {
        const modelInput = veiculoPendencia.principal ? 'unshift' : 'push';
        this.fichaCadastro.veiculosGetDados[modelInput](
          new VeiculoSimulacao({ placa: veiculoPendencia.placa })
        );
      }
    });
  }

  private handleErrorSimulacao(error, dadoSimulacao: DadoSimulacao) {
    this.isConsultarAnaliseProposta = false;
    this.isExecutandoSimulacao = false;
    this.tentativaDados = 0;
    if (error.status === this.FIPE_NOT_FOUND) {
      this.handleErroFipeNaoEncontrada(error);
    } else if (error.status === this.PLACA_INVALIDA) {
      this.fichaCadastro.setErrorStatus(error.status);
      this.perguntaCorrigirDadosPlaca(error, dadoSimulacao);
    } else if (error.status === this.GARANTIA_RECUSADA) {
      this.perguntaCorrigirGarantia(error, dadoSimulacao);
    } else if (error.status === this.TAXA_CLIENTE_NOT_FOUND) {
      this.handleErroTaxaClienteNaoEncontrada(error);
    } else if (error.status === this.ERRO_CRIVO) {
      this.handleErroCrivo(error);
    } else if (error.status === this.REFUSED) {
      this.handleErrorRefused(error);
    } else {
      this.handleErroInesperado(error);
    }
  }

  private handleErroInesperado(error) {
    this.tentativaDados = 1;
    if (error && error.message) {
      this.showErrorMessage(error.message, () => this.home());
    } else {
      this.showErrorMessage(
        error.error.messages[0] ||
          'Não foi possível realizar a simulação. Verifique sua conexão com a internet e tente novamente.',
        () => this.home()
      );
    }
  }

  private handleErroPlacaInvalida(error: any, result) {
    this.tentativaDados = 0;
    const proposta = new PropostaSimulacao(result);
    this.mergeVeiculoPendenciaGetDados();
    this.fichaCadastro.setIdSimulacao(proposta.getIdSimulacao());
    this.sharedService.verificaPendenciaVeiculo();
    this.fichaCadastro.passoCorrigirPLacaInvalida();
    this.sharedService.selecionarVeiculoManualmente();
  }

  private perguntaCorrigirDadosPlaca(error: any, result) {
    this.hideClose = false;
    this.modalMessage.show(
      'Não foi possível completar a simulação.\n\n A placa informada é inválida. Deseja preencher as informações do veículo manualmente ?',
      'Sim',
      'Não'
    );
    this.modalMessage.ok
      .pipe(take(1))
      .subscribe(() => this.handleErroPlacaInvalida(error, result));
    this.modalMessage.close
      .pipe(take(1))
      .subscribe(() => this.handleErroPlacaInvalida(error, result));
    this.modalMessage.modalClose.subscribe();
  }

  private perguntaCorrigirGarantia(error: any, result) {
    this.hideClose = false;
    this.modalMessage.show(
      'Não foi possível completar a simulação.\nA garantia informada foi recusada. Deseja informar outra placa ?',
      'Sim',
      'Não'
    );
    this.modalMessage.ok
      .pipe(take(1))
      .subscribe(() => this.handleErroPlacaInvalida(error, result));
    this.modalMessage.close.pipe(take(1)).subscribe(() => this.home());
    this.modalMessage.modalClose.subscribe();
  }

  private handleErroFipeNaoEncontradaWithoutMessage(error: any) {
    this.sharedService.selecionarVeiculoManualmente();
    this.fichaCadastro.passoCorrigirFipeNotFound();
    this.fichaCadastro.hasUsado = true;
    this.fichaCadastro.setIdSimulacao(error.id);
  }

  private handleErroFipeNaoEncontrada(error: any) {
    this.showErrorMessage(error.message, () => {
      this.sharedService.selecionarVeiculoManualmente();
      this.fichaCadastro.passoCorrigirFipeNotFound();
      this.fichaCadastro.setIdSimulacao(error.id);
    });
  }

  private handleErroTaxaClienteNaoEncontrada(error: any) {
    this.showErrorMessage(error.message, () => this.home());
  }

  private handleErroCrivo(error: any) {
    this.showErrorMessage(error.message, () => this.home());
  }

  private handleErrorRefused(message) {
    this.showErrorMessage(message, () => this.home());
  }

  private home() {
    this.router.navigate(['/ficha']);
  }

  private showErrorMessage(message: string, next: () => void) {
    this.hideClose = true;
    this.modalMessage.show(message).modalClose.pipe(take(1)).subscribe(next);
  }
}
